import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PaymentService from "../../../../service/payment-service";
import { LINE_URL } from "../../../../constant/contact";

//—— 命書的最後一頁 ——
//
//  27 節讀完之後的收尾：留一則評價、聯絡官方 LINE、回首頁。
//
//  —— 為什麼評價表單直接長在這一頁，不另開一頁 ——
//  它是一本書的最後一頁，不是一個流程。再跳一次頁就變成「填表單」，
//  而這裡要的是「讀完了，順手說一句」。
//
//  props:
//    bookID    orderID。沒有就不顯示評價（評價要綁單）
//    reviewed  這張單已經評過了（來自 P-10 的 reviewed）
//    bg        底圖的網址

const BaiyeReportOutro = ({ bookID, reviewed, bg }) => {
  const navigate = useNavigate();
  const [rating, setRating] = useState(0);
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);
  //送出成功，或進來時就已經評過
  const [done, setDone] = useState(Boolean(reviewed));
  const [error, setError] = useState("");

  const submit = () => {
    if (!rating || sending) return;
    setSending(true);
    setError("");
    PaymentService.orderReview(bookID, { rating, text })
      .then(({ data }) => {
        if (data?.status) setDone(true);
        else setError(data?.message || "送出失敗");
      })
      .catch((e) => setError(e?.response?.data?.message || "送出失敗"))
      .finally(() => setSending(false));
  };

  return (
    <section
      className="baiye-report__outro"
      style={{ "--outro-bg": `url(${bg})` }}
    >
      {/* 評價。沒有 bookID（例如之後拿這支元件預覽）就整塊不掛 */}
      {bookID && (
        <div className="baiye-report__card">
          {done ? (
            <p className="baiye-report__thanks">
              收到了。你說的話我記著。
            </p>
          ) : (
            <>
              <h3 className="baiye-report__card-title">這份命書，你覺得如何</h3>

              <div
                className="baiye-report__stars"
                role="radiogroup"
                aria-label="評分"
              >
                {[1, 2, 3, 4, 5].map((n) => (
                  <button
                    key={n}
                    type="button"
                    role="radio"
                    aria-checked={rating === n}
                    aria-label={`${n} 星`}
                    className={`baiye-report__star${rating >= n ? " is-on" : ""}`}
                    onClick={() => setRating(n)}
                  >
                    ★
                  </button>
                ))}
              </div>

              <textarea
                className="baiye-report__memo"
                placeholder="想說什麼都可以（不寫也沒關係）"
                maxLength={1000}
                rows={4}
                value={text}
                onChange={(e) => setText(e.target.value)}
              />

              {error && <p className="baiye-report__error">{error}</p>}

              <button
                type="button"
                className="baiye-report__btn baiye-report__btn--primary"
                disabled={!rating || sending}
                onClick={submit}
              >
                {sending ? "送出中…" : "送出"}
              </button>
            </>
          )}
        </div>
      )}

      {/* 官方 LINE。網址走 constant/contact 的 LINE_URL ——
          原本這裡自己存了一份，而頁尾、兩支購票頁用的是 contact 那一份，
          換帳號時一定會漏掉其中一邊。 */}
      <a
        className="baiye-report__btn baiye-report__btn--line"
        href={LINE_URL}
        target="_blank"
        rel="noreferrer"
      >
        聯絡官方 LINE 客服
      </a>

      <button
        type="button"
        className="baiye-report__btn"
        onClick={() => navigate("/")}
      >
        回首頁看看其他的
      </button>
    </section>
  );
};

export default BaiyeReportOutro;
